import React, {useEffect, useState, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import {Button} from "react-bootstrap";
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import {toast} from "react-toastify";
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import FileUpload from "components/sales/fileUpload/fileUpload";

const HeadIncentiveLists = (
    {
        match,
        history,
        getUserSeniorIncentiveSum,
        fullHeadIncentiveList,
        documentUploadUrlPublic,
        documentUrlDataPublic,
        uploadIncentiveUtrFile,
    }
) => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const [isModal, setIsModal] = useState(false);
    const [actionData, setActionData] = useState(false);
    const [isSuccessModel, setIsSuccessModel] = useState(false);
    const handleModalHide = () => setIsModal(false);
    const [file, saveFile] = useState("");
    const headers = [
        'Name',
        'Role',
        'Total Incentive',
        'Status'
    ];
    //console.log(fullIncentiveList);
    useEffect(() => {
        (async () => { 
            setIsLoading(true)
            getUserSeniorIncentiveSum(2);
            setIsLoading(false)
        })()
    }, []);

    const handleModalHideComponant = () => {
        setIsModal(false);
        window.location.reload();
    }

    const showModel = async (val) => {
        if(val === true) {
           setIsModal(true);
           setActionData(true);
        }
    }

    const handleContinue = async () => {      
        const requestData = {
           file: file,
          'type': 'user',
          'key': 0,
        }; 
          setIsLoading(true);
             await uploadIncentiveUtrFile(requestData).then(async (response) => { 
             if(response === true) {
                setActionData(false);
             }   
             setIsLoading(false);
          });
    };

    const successIconBox = (text, func) => {
        return (
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{text}</h5>
            <Link to="#" onClick={func} className="btn btn-transparent">
              {localization.returnToIncentive}{' '}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        );
      };  
    
    useEffect(() => {
        const tableData = [
            'name',
            'title',
            'total_incentive',
            'head_utr_no'
        ];

        if (Object.keys(fullHeadIncentiveList).length > 0) { 
            const data = fullHeadIncentiveList.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ( 
                        (key === 'head_utr_no' && element['head_utr_no'] === null) ? 
                        {[key]: 'Unpaid'} : {[key]: element[key]} 
                          
                        )
                    )
                )
            );  
            data && setListData(data);
            //setPageCount(Math.ceil(incentiveListFinance.total / incentiveListFinance.per_page));
        } else{
            setListData([]);
        }
    }, [fullHeadIncentiveList]);

    const exportExcel = (val) => {
        if(val === 2) { 
            (async () => {
                const url = `${Config.postSales.excelExportIncentive}?key=${val}`;
                setIsLoading(true);
                const { data } = await axios.get(url);
                if(data !== "" && data !== null) {
                    //console.log('url ' + data);
                    window.location.href = data;
                    setIsLoading(false);
                  }
            })();    
        }
    } 

    const headerBtns = () => {
        return (
            <div className="Pm-btn pm-btn-align">
             <button onClick={() => showModel(true)} className="btn btn-primary d-none d-md-inline-block">Upload UTR</button>
             <button onClick={() => exportExcel(2)} className="btn btn-primary d-none d-md-inline-block">Export List</button>
            </div>
        )
    }

    return (
        <Layout
            title={localization.headIncentive}
            isLoading={isLoading}
            Buttons={fullHeadIncentiveList && fullHeadIncentiveList.length > 0 ? headerBtns:''}
        > 
        <>
        <div className="container-fluid">
        <div className="card mt-2">
        <div className="card-header">
                {localization.incentiveList}
        </div>
            <div className="card-header">
            <div className="card-body">
            <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    //pageCount={pageCount}
                    //onPageChange={onPageChange}
                    //onChange={(data) => {updateApproval(data)}}
                    //detailList={listData && listData}
                    //srNo={getSiteRepositoryDetails?.from}
            />
            </div>
            </div>
        </div>
        </div>

        <ModalPop
                title={localization.uploadUtr}
                show={isModal}
                handleModalHide={handleModalHide}
                actionData={actionData}
            >
            {actionData && actionData === true ? (
            <Fragment>
                <div className="modal-body">
                <div className="text-center">
                    <div className="form-group-k">
                    <FileUpload
                        isBase64={true}
                        id={"attachment"}
                        accept=".csv"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={(val) =>
                            saveFile(val)
                        }
                        >
                        <span className="btn btn-transparent">
                            {localization.uploadYourFile}
                        </span>        
                    </FileUpload>
                    <h5><br />{localization.uploadUserUtr}</h5>
                    </div>
                    <Button
                    className="btn btn-primary text-center"
                    onClick={handleContinue}
                    disabled={!file}
                    >
                    {localization.continue}{' '}
                    <img src="../images/arrow-right.png" alt="" />
                    </Button>
                </div>
                </div>
            </Fragment>
            ) : (
            <Fragment>
                {successIconBox(localization.utrUploadedSuccessfully, handleModalHideComponant)}
            </Fragment>
            )}
            </ModalPop>
        </>
        </Layout>
    )
}

export default HeadIncentiveLists;